import { useCallback, useRef } from "react";

/**
 * Custom hook to manage scroll restoration.
 */
export const useScrollRestoration = () => {
    const scrollPositionRef = useRef<number>(0);

    const scrollToTop = useCallback(() => {
        scrollPositionRef.current = window.scrollY;
        setTimeout(() => window.scrollTo(0, 0), 50);
    }, []);

    const scrollToPrevious = useCallback(() => {
        setTimeout(() => {
            window.scrollTo(0, scrollPositionRef.current);
        }, 50);
    }, []);

    return { scrollToTop, scrollToPrevious };
};
